<template>
  <div class="w-full">
    <HomeHero />
    <HomeRecent />
    <HomeFeaturedArtists />
    <HomeActions />
    <HomeAbout />
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();

useSeoMeta({
  title: () => t("homepage_seo_meta.page_heading"),
  description: () => t("homepage_seo_meta.description"),
  ogTitle: () => t("homepage_seo_meta.ogTitle"),
  ogDescription: () => t("homepage_seo_meta.ogDescription"),
  ogImage: "https://medium.am/logo.png",
  twitterImage: "https://medium.am/logo.png",
  ogType: "website",
  twitterCard: "summary",
});
</script>
